import clsx, { ClassValue } from "clsx";
import type { TFunction, i18n } from "i18next";
import { twMerge } from "tailwind-merge";

export const cn = (...inputs: ClassValue[]): string => {
  return twMerge(clsx(inputs));
};

export const translateIfExists = (
  t: TFunction,
  translationInstance: i18n,
  key: string,
  fallback: string,
): string => {
  return translationInstance.exists(key, { ns: "translation" })
    ? String(t(key as never))
    : fallback;
};

export const fromUnderscoreToTitleCase = (str: string): string => {
  return (
    str
      ?.split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ") ?? ""
  );
};

export const toSnakeCase = (value: string, trim?: boolean): string => {
  let convertedValue = value
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/[\s\-]+/g, "_")
    .replace(/[^a-zA-Z0-9_]/g, "");

  if (trim) {
    convertedValue = convertedValue.replace(/_+/g, "_").replace(/^_|_$/g, "");
  }
  return convertedValue.toLowerCase();
};
